export default __webpack_public_path__ + "static/christian_pilon-0faf2c31e43d686a9910aec430b6daf3.jpg";